import { Pagination } from "services/search";
import { DataWithPagination } from "../types";
import {
  PriceList,
  PriceListEditFormValues,
  PriceListRow,
  PriceTable,
} from "./types";
import { createApiCall, paginatedApiCall } from "../createApiCall";
import {
  transformPriceList,
  transformPriceListOnCreate,
  transformPriceListOnUpdate,
  transformPriceListRow,
  transformPriceTable,
} from "./transformations";
import { transformErrorResponse } from "../transformation";

/*---------------------------------------------------------------------------------------
  PRICE LIST SEARCH
-----------------------------------------------------------------------------------------*/
export const getPriceListsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<PriceListRow>> => {
  let path = `/v1/expenses/rent?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformPriceListRow);
};

/*---------------------------------------------------------------------------------------
     PRICE LIST - BY ID
-----------------------------------------------------------------------------------------*/
export const getPriceListAPI = async (id: string): Promise<PriceList> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/rent/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformPriceList(response.data);
};

/*---------------------------------------------------------------------------------------
     PRICE LIST - CREATE
-----------------------------------------------------------------------------------------*/
export const createPriceListAPI = async (
  formValues: PriceListEditFormValues
): Promise<PriceList> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/rent/",
      method: "POST",
      body: transformPriceListOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Cjenik je uspješno kreiran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformPriceList(response.data);
};

/*---------------------------------------------------------------------------------------
     - PRICE LIST - UPDATE
-----------------------------------------------------------------------------------------*/
export const updatePriceListAPI = async (
  id: string,
  formValues: PriceListEditFormValues
): Promise<PriceList> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/rent/${id}`,
      method: "PUT",
      body: transformPriceListOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Cjenik je uspješno ažurirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformPriceList(response.data);
};

/*---------------------------------------------------------------------------------------
   PRICE - DELETE
-----------------------------------------------------------------------------------------*/
export const deletePriceListAPI = async (id: string): Promise<PriceList> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/rent/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Cjenik je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformPriceList(response.data);
};

/*---------------------------------------------------------------------------------------
     PRICE - TABLE
-----------------------------------------------------------------------------------------*/

export const getPriceTableAPI = async (id: string): Promise<PriceTable> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/rent/${id}/table`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformPriceTable(response.data);
};
